<template>
  <section
    class="text-center container col-lg-8 col-md-9 col-sm-10 mx-auto mt-2 mb-4"
  >
    <h1 class="animate-characters">The Surviville Card Game</h1>

    <template v-if="showSummary % 2 === 0">
      <table class="mx-auto my-4">
        <tr>
          <td v-for="idx in 3" :key="idx">
            <img
              class="button"
              @click="uncoverField(idx - 1)"
              :src="imgArr[idx - 1]"
            />
          </td>
        </tr>
        <tr>
          <td v-for="idx2 in 3" :key="idx2">
            <img
              class="button"
              @click="uncoverField(idx2 + 2)"
              :src="imgArr[idx2 + 2]"
            />
          </td>
        </tr>
        <tr>
          <td v-for="idx3 in 3" :key="idx3">
            <img
              class="button"
              @click="uncoverField(idx3 + 5)"
              :src="imgArr[idx3 + 5]"
            />
          </td>
        </tr>
      </table>

      <h1 class="mt-4">Card {{ currentCard }} of {{ cards2Play }}</h1>

      <span class="row-lg-12">
        <span class="column">
          <div class="col-lg-6 col-md-8 mx-auto">
            <button
              v-if="uncoveredWinningFields < 3"
              class="btn btn-std my-2 btn-large"
              @click="uncoverAllFields"
            >
              Uncover all fields
            </button>
            <button
              v-else-if="currentCard < cards2Play"
              class="btn btn-std my-2 btn-large"
              @click="showNextCard"
            >
              Show next card
            </button>
            <button
              v-else
              class="btn btn-std my-2 btn-large"
              @click="showNextCard"
            >
              Get New Cards
            </button>
            <template
              v-if="
                showSummary === 2 ||
                (currentCard >= cards2Play && uncoveredWinningFields >= 3)
              "
            >
              &nbsp;
              <button
                class="btn btn-std my-2 btn-large"
                @click="
                  showSummary = 1;
                  currentCard = cards2Play;
                "
              >
                Show Summary
              </button>
            </template>
          </div>
        </span>
      </span>

      <div class="row">
        <h3 class="text-monospace col-lg-12 col-md-12 mx-auto">
          {{ feedbackMessage }}
        </h3>
      </div>
    </template>

    <template v-if="currentCard < cards2Play || uncoveredWinningFields < 3">
      <h5 v-if="uncoveredWinningFields < 3">
        Click the fields above or the button below to uncover your winnings.
      </h5>
      <h5 v-else>
        A summary of your winnings is accessible after uncovering the last card.
      </h5>
    </template>

    <template v-if="showSummary === 1">
      <table class="mx-auto my-4">
        <tr
          v-for="idx in winningsArr.length"
          :key="idx"
          class="text-muted lead"
        >
          <a
            href="#"
            @click="
              showSummary = 2;
              currentCard = idx;
              showCard(idx);
            "
          >
            {{ idx }}. card won
            {{ winningsArr[idx - 1] }}
            SVC</a
          >
        </tr>

        <hr class="my-3" />

        <tr class="text-muted lead">
          Total won:
          {{
            tokensWon
          }}
        </tr>
      </table>

      <h5>
        You can replay any of the above cards by clicking on them or playing new
        cards by clicking the button below.
      </h5>

      <button class="btn btn-std my-2 btn-large" @click="showNextCard">
        Get New Cards
      </button>
    </template>

    <!-- <button class="btn btn-std my-2 btn-large" @click="simulateGame">
      Simulate Game
    </button>
    <br /> -->
  </section>
</template>

<script>
const payouts = [5000, 2500, 1000, 500, 250, 200, 150, 125, 0];

export default {
  name: "App",
  props: ["cards2Play", "tokensWon", "gameStats"],
  emits: ["cardsPlayed"],

  data() {
    return {
      currentCard: 1,
      winningsArr: [],
      cardFieldsMap: {},

      imgArr: [],
      uncoveredImgArr: [],
      uncoveredWinningFields: 0,

      showSummary: 0,

      feedbackMessage: "",
    };
  },

  methods: {
    shuffle: function (array) {
      let currentIndex = array.length;
      let randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ];
      }

      return array;
    },

    showNextCard: function () {
      this.currentCard++;
      if (this.currentCard > this.cards2Play) {
        this.$emit("cardsPlayed");
      } else {
        this.showCard(this.currentCard);
      }
    },

    uncoverField: function (_fieldNr) {
      let _uncoveredField =
        "images/cards/" + this.uncoveredImgArr[_fieldNr] + ".png";
      if (this.imgArr[_fieldNr] === _uncoveredField) {
        return false;
      }
      this.imgArr[_fieldNr] = _uncoveredField;

      // console.log(
      //   this.uncoveredImgArr[_fieldNr],
      //   this.winningsArr[this.currentCard - 1]
      // );

      if (
        Number(this.uncoveredImgArr[_fieldNr]) ===
        Number(this.winningsArr[this.currentCard - 1])
      ) {
        this.uncoveredWinningFields += 1;
      }

      if (this.uncoveredWinningFields >= 3) {
        this.feedbackMessage =
          "This card wins " + this.winningsArr[this.currentCard - 1] + " SVC";
      }
    },

    uncoverAllFields: function () {
      for (let i = 0; i < 9; ++i) {
        this.uncoverField(i);
      }
    },

    generateFieldNumbers: function (_cardWins) {
      let fieldNumbers = [];
      let _nonwinningNumbers = [];
      // creating card
      // nonwinning numbers
      for (let i = 0; i < payouts.length; ++i) {
        let _payout = payouts[i];
        if (Number(_payout) === Number(_cardWins)) {
          continue;
        }
        for (let j = 1; j <= 2; ++j) {
          _nonwinningNumbers.push(_payout);
        }
      }
      // console.log("nonwinningNumbers", nonwinningNumbers);
      this.shuffle(_nonwinningNumbers);
      fieldNumbers = _nonwinningNumbers.slice(0, 6);
      // console.log(fieldNumbers);
      // winning numbers
      for (let i = 1; i <= 3; ++i) {
        fieldNumbers.push(_cardWins);
      }
      this.shuffle(fieldNumbers);

      return fieldNumbers;
    },

    showCard: function (_card) {
      const cardWins = this.winningsArr[_card - 1];
      // console.log(_card, "wins", cardWins);

      let _fieldNumbers = [];
      if (_card in this.cardFieldsMap) {
        _fieldNumbers = this.cardFieldsMap[_card];
      } else {
        _fieldNumbers = this.generateFieldNumbers(cardWins);
        this.cardFieldsMap[_card] = _fieldNumbers;
      }
      // console.log(_fieldNumbers);

      // resetting card display
      this.feedbackMessage = "";
      this.uncoveredWinningFields = 0;
      this.imgArr = [];
      this.uncoveredImgArr = [];
      for (let i = 0; i < 9; ++i) {
        this.imgArr.push("images/cards/svc.png");
      }

      this.uncoveredImgArr = _fieldNumbers;
    },

    buildWinningsArr: function (w, _cards2Play) {
      // console.log(w);
      let _winningsArr = [];
      for (const [key, value] of Object.entries(w)) {
        // console.log(`${key}: ${value}`);
        for (let i = 0; i < value; ++i) {
          _winningsArr.push(key);
        }
      }
      for (let i = _winningsArr.length; i < _cards2Play; ++i) {
        _winningsArr.push(0);
      }
      // console.log("_winningsArr before shuffle", _winningsArr);

      this.winningsArr = this.shuffle(_winningsArr);
      // console.log("winningsArr after shuffle", this.winningsArr);
      this.showCard(1);
      // for (let i = 0; i < winningsArr.length; ++i) {
      //   this.playCard(winningsArr[i]);
      // }
    },

    // simulateGame: function () {
    //   let _cards2Play = 50;
    //   let _tokensWon = 9500;
    //   let _gameStats = 2073862;

    //   this.extractGameInfo(_cards2Play, _tokensWon, _gameStats);
    // },

    extractGameInfo: function (_cards2Play, _tokensWon, _gameStats) {
      // console.log("PlayCards:extractGameInfo");
      console.log("You played", _cards2Play, "cards");

      let returnString = "";
      if (_tokensWon <= 0) {
        returnString =
          "Unfortunately, you did not win anything! Better luck next time!";
      } else {
        returnString = "Congratulations! You won " + _tokensWon + " SVC. \n\n";
      }

      const modulos = [2057701, 542351, 111701, 16151, 1351, 51, 1];
      const payoutsWithModulos = [5000, 2500, 1000, 500, 250, 200, 150];
      let w = {};
      for (let i = 0; i < modulos.length; ++i) {
        w[payoutsWithModulos[i]] = Math.floor(_gameStats / modulos[i]);
        _gameStats = _gameStats - modulos[i] * w[payoutsWithModulos[i]];
        _tokensWon =
          _tokensWon - payoutsWithModulos[i] * w[payoutsWithModulos[i]];
        returnString +=
          w[payoutsWithModulos[i]] > 0
            ? w[payoutsWithModulos[i]] + "x " + payoutsWithModulos[i] + " won, "
            : "";
      }

      w[125] = Math.floor(_tokensWon / 125);
      returnString += w[125] > 0 ? w[125] + "x " + 125 + " won " : "";

      // console.log(w);

      if (_tokensWon - w[125] * 125 !== 0) {
        console.log("Calculation did not work");
        console.log("Rest", _tokensWon - w[125] * 125);
      } else {
        console.log("Calculation worked");
      }

      console.log(returnString);

      this.buildWinningsArr(w, _cards2Play);
    },
  },

  mounted: function () {
    // console.log("Play Cards mounted");
    let _cards2Play = this.cards2Play;
    let _tokensWon = this.tokensWon;
    let _gameStats = this.gameStats;

    for (let i = 0; i <= 9; ++i) {
      this.imgArr.push("images/cards/svc.png");
    }

    this.extractGameInfo(_cards2Play, _tokensWon, _gameStats);
  },
};
</script>

<style scoped>
/* @font-face {
  font-family: "Agency FB";
  font-style: normal;
  font-weight: 400;
  src: local("Agency FB"), local("AgencyFB-Regular"),
    url(../assets/fonts/agency-fb.woff) format("woff"),
    url(../assets/fonts/agency-fb.ttf) format("truetype");
} */

@font-face {
  font-family: "Agency FB Bold";
  font-style: normal;
  font-weight: 700;
  src: local("Agency FB Bold"), local("AgencyFB-Bold"),
    url(../assets/fonts/agency-fb-bold.woff) format("woff"),
    url(../assets/fonts/agency-fb-bold.ttf) format("truetype");
}

.animate-characters {
  font-family: "Agency FB Bold", arial;
  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #d8ee0e 0%,
    #eeba0e 22%,
    #eb4c07 67%,
    #d8ee0e 100%
  );
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 10s ease-in-out infinite;
  display: inline-block;
}

.text-muted {
  font-family: "Agency FB Bold", arial;
  color: #d7be7b !important;
}

.btn-std {
  font-family: "Agency FB Bold", arial;
  color: #292b2c;
  background-color: #fad87a;
  border-color: #fad87a;
}

.btn-std:disabled {
  color: #292b2c;
  background-color: #fff3d3;
  border-color: #fff3d3;
}

.btn-std:not([disabled]):hover {
  color: rgb(6, 6, 6);
  background-color: #ffce44;
  border-color: transparent;
  box-shadow: 0 0 5px #f2d279, 0 0 25px #f9df96, 0 0 50px #fcebbd,
    0 0 200px #fff3d3;
}

.btn-std:not([disabled]):focus,
.btn-std:not([disabled]):active {
  color: rgb(6, 6, 6);
  background-color: #ffce44;
  border-color: transparent;
  box-shadow: 0 0 5px #f2d279, 0 0 10px #f9df96, 0 0 20px #fcebbd,
    0 0 50px #fff3d3;
}

img:hover {
  box-shadow: 0 0 5px #f2d279, 0 0 10px #f9df96, 0 0 20px #fcebbd,
    0 0 50px #fff3d3;
}

hr {
  border-top: 2px solid #caaf63;
  box-shadow: 0 0 5px #f2d279, 0 0 10px #f9df96, 0 0 20px #fcebbd,
    0 0 50px #fff3d3;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Agency FB Bold", arial;
  color: #f9d164;
}

a {
  color: #f9d164;
}

table,
th,
td {
  border: 2px solid 131129;
  border-collapse: collapse;
}
th,
td {
  background-color: rgb(0, 0, 0);
}
</style>
